import { PhoneInput, PhoneInputProps } from '@makyoapp/makyo-tw-ui'

export const CompPhoneInputCore = (props: PhoneInputProps) => {
  return <PhoneInput {...props} />
}
